const getImageUrl = ({ file_name }) => `https://static.wixstatic.com/media/${file_name}`;
const getVideoUrl = ({ pathname }) => `https://video.wixstatic.com/${pathname}`;
const getThumbnailUrl = ({ pathname }) => {
  const prefix = pathname.startsWith("media/") ? "" : "media/";
  return `https://static.wixstatic.com/${prefix}${pathname}`;
};
const getAudioUrl = ({ id }) => `https://static.wixstatic.com/${id}`;
export {
  getAudioUrl,
  getImageUrl,
  getThumbnailUrl,
  getVideoUrl
};
//# sourceMappingURL=url-resolvers.js.map
